import { useContext } from "react";
import { Grid, Stack, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
//Srcs
import "../Setting/setting.scss";
import { AuthContext } from "../../Context/AuthContext";
import ExpenseIcon from "../../Assets/expense_icon.png";
// import ContentIcon from "../../Assets/content.png";
// import PackagePrice from "../../Assets/package-price.png";
// import OptionPrice from "../../Assets/package-price-name.png";
import ReportIcon from "../../Assets/report_icon.png";
import { PageHeaderTitle } from "../../Utils/Component";

export default function Other() {
  // Change Language
  const { t } = useContext(AuthContext);
  const SettingData = [
    {
      icon: <img alt="Exam icon" className="image" src={ExpenseIcon} />,
      path: "/other/expense",
      title: t("page_expense"),
      description: t("thead_description_expense"),
    },
    // {
    //   icon: <img alt="Exam icon" className="image" src={ContentIcon} />,
    //   path: "/other/content",
    //   title: t("page_content"),
    //   description: t("thead_description_content"),
    // },
    // {
    //   icon: <img alt="Exam icon" className="image" src={ContentIcon} />,
    //   path: "/other/lesson",
    //   title: t("page_lesson"),
    //   description: t("thead_description_lesson"),
    // },
    // {
    //   icon: <img alt="Exam icon" className="image" src={PackagePrice} />,
    //   path: "/other/package_price",
    //   title: t("page_package_price"),
    //   description: t("thead_description_package_price"),
    // },
    // {
    //   icon: <img alt="Exam icon" className="image" src={OptionPrice} />,
    //   path: "/other/option_price_name",
    //   title: t("page_option_price_name"),
    //   description: t("thead_description_option_price_name"),
    // },
    {
      icon: <img alt="Exam icon" className="image" src={ReportIcon} />,
      path: "/other/report",
      title: t("page_report"),
      description: t("thead_description_report"),
    },
  ];

  return (
    <div className="setting-page">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/other"}
        pageTitle={t("page_other")}
      />

      <Box sx={{ mt: "30px" }}>
        <Grid container spacing={4}>
          {SettingData?.map((e, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Link to={e?.path} style={{ textDecoration: "none" }}>
                <Stack
                  spacing={3}
                  direction="row"
                  className="setting-page-container"
                >
                  <Stack
                    direction="column"
                    justifyContent="center"
                    className="page-image"
                  >
                    {e?.icon}
                  </Stack>
                  <Stack direction="column" justifyContent="center">
                    <Stack direction="column">
                      <Typography className="page-title">{e?.title}</Typography>
                      <Typography className="page-description">
                        {e?.description}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
}
